/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-final-form';
import memoize from 'lru-memoize';

import strings from '../../../lang/lang';
import { DesktopAndTablet, Mobile } from '../../../utils/responsiveQueries';

import Button from '../../../elements/Button/Button';
import { showSuccess, showError } from '../../../elements/Toasts/toastActions';
import { FormInput } from '../../../elements/Form';
import { appsActions } from '../../../redux/reducers/apps';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { createValidator, required, url, auth } from '../../../redux/utils/validation';
import { webhookActions, webhookState, webhookStateLoaded } from '../../../redux/reducers/webhook';

import { ReactComponent as SaveIcon } from '../../../styles/icon/save.svg';
import { ReactComponent as ArrowBack } from '../../../styles/icon/arrow-back.svg';

import Icons from '../../../components/Icons';
import Routes from '../../../components/Routes';
import WebhookPanelContainerMobile from '../../../components/WebhookPanelContainerMobile';

import WebhookBreadcrumbs from './WebhookBreadcrumbs';
import WebhookCertificate from './WebhookCertificate';
import Modals from './Modals/ModalsContainer';
import WebhookSecrets from './WebHookSecrets';
import TestRequest from './TestRequest';
import handleError from './handleError';
import DangerZone from './DangerZone';
import settings from '../Settings.module.scss';


function WebhookDetails(props) {
  const { match } = props;
  const [appId] = useState(match.params.id);
  const [webhookId] = useState(match.params.webhookId);
  const dispatch = useAppDispatch();
  const webhookDetails = useAppSelector(webhookState);
  const webhookDetailsLoaded = useAppSelector(webhookStateLoaded);

  useEffect(() => {
    const breadCrumbElement = document.getElementById('webhook-breadcrumb-id');
    if (breadCrumbElement && webhookDetailsLoaded) {
      breadCrumbElement.innerText = webhookDetails['eventTypeName'];
    }
  }, [webhookDetails, webhookDetailsLoaded]);

  useEffect(() => {
    dispatch(appsActions.loadAppDetails({ id: appId }));
    dispatch(webhookActions.loadWebhookDetails({ appId, webhookId }));
  }, []);

  function handlePauseResumeButton(action) {
    return new Promise((res, rej) => {
      dispatch(webhookActions.pauseResumeWebhook({ action, res, rej }));
    })
    .then(() => {
      if (action === 'pause') {
        showSuccess(strings.appWebhookDetails.text.successPause);
      } else {
        showSuccess(strings.appWebhookDetails.text.successResume);
      }
    })
    .catch(() => {
      showError(strings.appWebhookDetails.errors.pausingResumingException);
    });
  }

  const validate = memoize(10)(
    createValidator({
      url: [required, url, auth],
    })
  );

  function onSubmit({ url }) {
    return new Promise((res, rej) => {
      const data = { url };
      dispatch(webhookActions.updateWebhook({ data, res, rej }));
    })
    .then(() => {
      showSuccess(strings.appWebhookDetails.text.successSaving);
    })
    .catch((error) => {
      handleError(error);
    });
  }

  const status = webhookDetails['status'] || '';
  return (
    <Fragment>
      <DesktopAndTablet>
        <WebhookBreadcrumbs />
      </DesktopAndTablet>
      <Mobile>
        <WebhookPanelContainerMobile />
      </Mobile>
      <div className={settings.settings}>
        <div className={settings.settings__box}>
          <DesktopAndTablet>
            <div className={settings.settings__back}>
              <Link to={Routes.routes.APPS.routes.WEBHOOKS.path.replace(':id', appId)}>
                <Button name={strings.appSpace.buttons.back} variant="back">
                  <ArrowBack />
                </Button>
              </Link>
            </div>
          </DesktopAndTablet>
          <div className={settings.settings__container}>
            <h1>{strings.appWebhookDetails.text.title}</h1>
            <Form
              onSubmit={onSubmit}
              validate={validate}
              initialValues={{
                url: webhookDetails['url'],
                event: webhookDetails['eventTypeName'],
                status: webhookDetails['status'],
              }}
              render={({ handleSubmit }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className={settings.settings__wrap}>
                      <FormInput
                        id="url"
                        name="url"
                        label={strings.appWebhookDetails.fields.url}
                        className="webhook_details"
                      />
                      <FormInput
                        id="event"
                        name="event"
                        label={strings.appWebhookDetails.fields.event}
                        disabled
                        className="webhook_details"
                      />
                      <FormInput
                        id="status"
                        name="status"
                        label={strings.appWebhookDetails.fields.status}
                        value={webhookDetails['status'] || ''}
                        disabled
                        className="webhook_details"
                      />
                      <TestRequest
                        data={webhookDetails}
                        appId={appId} //TODO: appId this is an old var
                      />
                      <WebhookSecrets />
                      <WebhookCertificate
                        appId={appId}
                        webhookId={webhookId}
                      />
                      <DangerZone />
                      <div className={settings.settings__pause_button_wrap}>
                        <Button
                          name={
                            status.toUpperCase() === 'REGISTERED'
                              ? strings.appWebhookDetails.buttons.pause
                              : strings.appWebhookDetails.buttons.resume
                          }
                          variant="primary"
                          secondaryClassName="lg"
                          disabled={status === 'BLOCKED'}
                          type="button"
                          onClick={() => {
                            const action = status.toUpperCase() === 'REGISTERED' ? 'pause' : 'resume';
                            handlePauseResumeButton(action);
                          }}
                        >
                          {status.toUpperCase() === 'REGISTERED' ? <Icons.pause /> : <Icons.play />}
                        </Button>
                      </div>
                      <div>
                        <Button
                          name={strings.appWebhookDetails.buttons.save}
                          variant="primary"
                          secondaryClassName="lg"
                          type="submit"
                        >
                          <SaveIcon />
                        </Button>
                      </div>
                    </div>
                  </form>
                );
              }}
            />
          </div>
        </div>
      </div>
      <Modals />
    </Fragment>
  );
}

export default WebhookDetails;
